export default function Contact() {
    return (
        
        <div className="border border-gray-800 rounded-md p-4 shadow-sm flex flex-col items-center justify-center text-center"> 
            <h2 className="mb-4 text-2xl font-bold">Contact</h2>
            <p>Ayat.A</p>
            <p>CS Student</p>

            <section>
                <h3 className="font-semibold mt-4">How to reach me </h3>
                <p> 📧 Email: ayattaa.a2@gmail.com</p>
                <p> 💻Discord: ay_ad1 </p>
             </section>

          <h3 className="font-semibold mt-4">Why QuranDetect?</h3>
      <p>
        This project was built to explore speech recognition and text matching
        while creating something meaningful and useful for everyday learning
        and reflection. </p>
           
        </div>
    
      

    );
}

